import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray} from 'lodash';

import {CategoryList} from '../catalog/catalog-constants';

const themeList = ({onChange, value, id}) => (
    <Dropdown
        filter={false}
        filterBy="label,value"
        filterPlaceholder="Select Theme"
        id={id}
        options={
            isArray(CategoryList)
                ? CategoryList.map(theme => ({
                      label: theme.label,
                      value: theme.value,
                  }))
                : []
        }
        showClear={false}
        style={{width: '300px'}}
        value={Number(value)}
        onChange={onChange}
    />
);

themeList.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default themeList;
